"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PusherProvider = void 0;
var React = __importStar(require("react"));
var PusherContext = React.createContext({});
exports.PusherProvider = PusherContext.Provider;
var parseEventKey = function (eventKey) { return eventKey.split('.'); };
var withPusher = function (config) { return function (WrappedComponent) {
    var _a;
    return _a = (function (_super) {
            __extends(WithPusher, _super);
            function WithPusher(props) {
                var _this = _super.call(this, props) || this;
                var values = config.mapPropsToValues(_this.props);
                _this.state = {
                    values: values,
                };
                return _this;
            }
            WithPusher.prototype.componentDidMount = function () {
                var _this = this;
                var fns = config.events;
                Object.entries(fns).forEach(function (_a) {
                    var eventKey = _a[0], fn = _a[1];
                    var _b = parseEventKey(eventKey), channelName = _b[0], eventName = _b[1];
                    _this.context
                        .subscribe(channelName)
                        .bind(eventName, function (event) {
                        _this.setState(function (prevState) { return (__assign(__assign({}, prevState), { values: __assign(__assign({}, prevState.values), fn(event, _this.state.values, _this.props)) })); });
                    });
                });
            };
            WithPusher.prototype.componentWillUnmount = function () {
                var _this = this;
                var fns = config.events;
                Object.entries(fns).forEach(function (_a) {
                    var eventKey = _a[0];
                    var _b = parseEventKey(eventKey), channelName = _b[0], eventName = _b[1];
                    _this.context
                        .channel(channelName)
                        .unbind(eventName);
                });
            };
            WithPusher.prototype.render = function () {
                return React.createElement(WrappedComponent, __assign({}, this.props, this.state.values));
            };
            return WithPusher;
        }(React.Component)),
        _a.contextType = PusherContext,
        _a;
}; };
exports.default = withPusher;
//# sourceMappingURL=index.js.map